import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Cause } from '@vi-iot/client';
import { HTMLExtractionPrefix } from 'src/app/shared/common/enums';

@Component({
  selector: 'app-possible-cause',
  templateUrl: './possible-cause.component.html',
  styleUrls: ['./possible-cause.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PossibleCauseComponent {
  @Input() causes: Cause[];
  HTMLExtractionPrefix = HTMLExtractionPrefix;
}
